import Script from 'next/script';

import { getBrandConfig } from '@/lib/configuration/configuration';

export function OneTrustScript() {
  return (
    <>
      <Script
        data-document-language='true'
        data-domain-script={getBrandConfig().oneTrustDataDomainScript}
        src='https://cdn.cookielaw.org/scripttemplates/otSDKStub.js'
        type='text/javascript'
      ></Script>
      <Script id='onetrust' type='text/javascript'>
        {`function OptanonWrapper() {
            if(!getCookie("OptanonAlertBoxClosed")){
              var newButton = document.createElement("button") // Create a button
              newButton.setAttribute("id", "onetrust-reject-all-handler") // Name the button + pick up style as per template
              newButton.setAttribute("aria-label", "Reject all cookies")
              newButton.innerHTML = "Reject all"
              newButton.onclick = function(one){
                OneTrust.RejectAll();
              }
              newButton.innerText = Optanon.GetDomainData().BannerRejectAllButtonText;// Add text to button
              document.getElementById("onetrust-policy").prepend(newButton) // Place button
              
              OneTrust.OnConsentChanged(function(){window.dataLayer.push({event : "OneTrustBannerClosed"});});
            }
            
            var tagsH2 = Array.from(document.getElementById('onetrust-consent-sdk').getElementsByTagName('h2')); 
            tagsH2.forEach(function(tag) { return otreplace(tag,"ot-h2");}); 
            var tagsH3 = Array.from(document.getElementById('onetrust-consent-sdk').getElementsByTagName('h3'));  
            tagsH3.forEach(function(tag) {return otreplace(tag,"ot-h3");}); 
            var tagsH4 = Array.from(document.getElementById('onetrust-consent-sdk').getElementsByTagName('h4')); 
            tagsH4.forEach(function(tag) {return otreplace(tag,"ot-h4");});
            
          }
            
          function getCookie(name) {
            var value = "; " + document.cookie;
            var parts = value.split("; " + name + "=");
            if (parts.length >= 2) return parts.pop().split(";").shift();
          }

          /*
          This function essentially comes from the official Onetrust documentation
          https://my.onetrust.com/s/article/UUID-69162cb7-c4a2-ac70-39a1-ca69c9340046?language=en_US
          A reinit condition was added to avoid unnecessary reloading
          */
          function reloadOTBanner() {
            const needsReinit =
              !getCookie("OptanonAlertBoxClosed") ||
              document.querySelector("#ot-sdk-cookie-policy") ||
              document.querySelector("#ot-sdk-btn") ||
              document.querySelector(".ot-sdk-show-settings") ||
              document.querySelector(".ot-sdk-cookie-settings") ||
              document.querySelector(".ot-floating-button") ||
              document.querySelector("[data-onetrust-show-settings]");

            if (!needsReinit) return;

            const otConsentSdk = document.getElementById("onetrust-consent-sdk");
            if (otConsentSdk) {
              otConsentSdk.remove();
            }

            if (window.OneTrust != null) {
              OneTrust.Init();

              setTimeout(() => {
                OneTrust.LoadBanner();

                const toggleDisplay = document.getElementsByClassName(
                  "ot-sdk-show-settings"
                );
                for (let i = 0; i < toggleDisplay.length; i++) {
                  toggleDisplay[i].onclick = function (event) {
                    event.stopImmediatePropagation();
                    window.OneTrust.ToggleInfoDisplay();
                  };
                }
              }, 1000);
            }
          }

          window.reloadOTBanner = reloadOTBanner;
          `}
      </Script>
    </>
  );
}
